/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { hubSpotLinkStore } from '../../axios/hubSpotLinkStore'
import type {
	HubSpotLinkStoreError,
	HubSpotLinkStorePathParams,
	HubSpotLinkStoreRequest,
	HubSpotLinkStoreResponse,
} from '../../types/HubSpotLinkStore'

export const hubSpotLinkStoreMutationKey = () => [{ url: '/:organisation/hubspot' }] as const

export type HubSpotLinkStoreMutationKey = ReturnType<typeof hubSpotLinkStoreMutationKey>

export type HubSpotLinkStoreVariables = {
	organisation: HubSpotLinkStorePathParams['organisation']
	data: HubSpotLinkStoreRequest
}

/** @see backend/nexus/modules/SupplyChain/Http/Controllers/HubSpotLinkController.php HubSpotLinkController::store */
export function useHubSpotLinkStore<TContext = unknown>(
	options?: UseMutationOptions<
		HubSpotLinkStoreResponse,
		AxiosError<HubSpotLinkStoreError>,
		HubSpotLinkStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: hubSpotLinkStoreMutationKey(),
		mutationFn: ({ organisation, data }: HubSpotLinkStoreVariables) =>
			hubSpotLinkStore(organisation, data, config).then(res => res.data),
		...options,
	})
}
